(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bm-home-categories"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCategories = scope => {
      const roots = scope.matches && scope.matches('[data-home-categories]') ? [scope] : scope.querySelectorAll('[data-home-categories]');
      roots.forEach(root => {
        if (root.dataset.initialized) return;
        root.dataset.initialized = 'true';
        const track = root.querySelector('.bm-home-categories__track');
        const controls = root.querySelector('.bm-home-categories__controls');
        const toggle = root.querySelector('[data-category-toggle]');
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        const autoplay = root.dataset.autoplay === 'true';
        let paused = false, hovered = false, focused = false, visible = true, timer;
        const canScroll = () => track.scrollWidth > track.clientWidth + 2;
        const advance = direction => {
          const item = track.querySelector('li');
          if (!item) return;
          const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
          const step = item.getBoundingClientRect().width + gap;
          const max = track.scrollWidth - track.clientWidth;
          const left = direction > 0 && track.scrollLeft >= max - 3 ? 0 : direction < 0 && track.scrollLeft <= 3 ? max : track.scrollLeft + direction * step;
          track.scrollTo({ left: Math.max(0, Math.min(max, left)), behavior: reduced.matches ? 'auto' : 'smooth' });
        };
        const schedule = () => {
          window.clearTimeout(timer);
          if (autoplay && !paused && !hovered && !focused && visible && !document.hidden && !reduced.matches && canScroll()) {
            timer = window.setTimeout(() => { advance(1); schedule(); }, 5000);
          }
        };
        const refresh = () => {
          controls.hidden = !canScroll();
          toggle.hidden = !autoplay;
          toggle.textContent = paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
          toggle.setAttribute('aria-pressed', String(paused));
          schedule();
        };
        controls.querySelectorAll('[data-category-direction]').forEach(button => button.addEventListener('click', () => { advance(Number(button.dataset.categoryDirection)); schedule(); }));
        toggle.addEventListener('click', () => { paused = !paused; refresh(); });
        root.addEventListener('pointerenter', () => { hovered = true; schedule(); });
        root.addEventListener('pointerleave', () => { hovered = false; schedule(); });
        root.addEventListener('focusin', () => { focused = true; schedule(); });
        root.addEventListener('focusout', () => { window.setTimeout(() => { focused = root.contains(document.activeElement); schedule(); }, 0); });
        track.addEventListener('pointerdown', () => { paused = true; refresh(); }, { passive: true });
        document.addEventListener('visibilitychange', schedule);
        reduced.addEventListener('change', refresh);
        if ('ResizeObserver' in window) new ResizeObserver(refresh).observe(track);
        else window.addEventListener('resize', refresh);
        if ('IntersectionObserver' in window) new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, { threshold: .15 }).observe(root);
        refresh();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initCategories(document), { once: true });
    else initCategories(document);
    document.addEventListener('shopify:section:load', event => initCategories(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-soul-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bm-soul-hero')) {
  customElements.define('bm-soul-hero', class extends HTMLElement {
    connectedCallback() { requestAnimationFrame(() => this.initialize()); }
    initialize() {
      if (!this.isConnected || this.video) return;
      this.video = this.querySelector('[data-bm-film]');
      this.button = this.querySelector('[data-bm-film-toggle]');
      if (!this.video || !this.button) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.userPaused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.video.defaultMuted = true;
      this.video.muted = true;
      this.video.playsInline = true;
      this.sync = () => {
        const paused = this.video.paused;
        const label = paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel;
        this.button.setAttribute('aria-label', label);
        this.button.querySelector('[data-bm-film-label]').textContent = label;
        this.button.querySelector('[data-bm-play]').toggleAttribute('hidden', !paused);
        this.button.querySelector('[data-bm-pause]').toggleAttribute('hidden', paused);
      };
      this.start = () => {
        if (this.userPaused || document.hidden) return;
        this.video.muted = true;
        const promise = this.video.play();
        if (promise) promise.catch(() => this.sync());
      };
      this.button.addEventListener('click', () => {
        if (this.video.paused) {
          this.userPaused = false;
          this.start();
        } else {
          this.userPaused = true;
          this.video.pause();
        }
      }, options);
      this.video.addEventListener('play', this.sync, options);
      this.video.addEventListener('pause', this.sync, options);
      this.video.addEventListener('canplay', this.start, options);
      window.addEventListener('pageshow', this.start, options);
      this.button.hidden = false;
      this.video.controls = false;
      if (this.userPaused) this.video.pause(); else this.start();
      this.sync();
    }
    disconnectedCallback() { this.abort?.abort(); this.video = null; }
  });
}

  } catch(e) { console.error(e); }
})();
})();
